export const team20 = [{
  "year": 2020,
  "CoreTeam": [
    {
      "Position": "Chairperson",
      "Name": "Madhurendra Tripathy",
      
      "ImgPath": "chair.jpeg"
    },
    {
      "Position": "Vice Chairperson",
      "Name": "Sweetha Aerpula",
     
      "ImgPath": "vice chair.jpeg"
    },
    {
      "Position": "Secretary",
      "Name": "Yashwanth Murarishetti",
      
      "ImgPath": "sceretary.jpeg"
    },
    {
      "Position": "Treasurer",
      "Name": "Vishal Kinnera",
      
      "ImgPath": "Tresurer.jpeg"
    },
    {
      "Position": "Membership Chair",
      "Name": "Jahnavi Neerukonda",
      
      "ImgPath": "membership.jpeg"
    },
    {
      "Position": "Webmaster",
      "Name": "Manaswini Nookala",
      
      "ImgPath": "web master.jpeg"
    }
  ],
  "TeamHeads": [
    ],
  "Volunteers": [
  {
    "Name": "CH. ULLAS REDDY",
    "Team": "Technical, Social Media",
    "Phone": "6303168891"
  },
  {
    "Name": "SHREYA POLA",
    "Team": "Tech Team",
    "Phone": "7396742253"
  },
  {
    "Name": "G CHARITHA",
    "Team": "Designing Team",
    "Phone": "6303274900"
  },
  {
    "Name": "M. VARSHITHA",
    "Team": "Events & PR Team",
    "Phone": "9381131474"
  },
  {
    "Name": "S. NIHARIKA",
    "Team": "Tech Team",
    "Phone": "9550043278"
  },
  {
    "Name": "SIDDARTH SAXENA",
    "Team": "Tech Team",
    "Phone": "8790838890"
  },
  {
    "Name": "Y. NIKITHA",
    "Team": "PR and Event Management",
    "Phone": "7729066800"
  },
  {
    "Name": "T RAJESHWAR RAO",
    "Team": "Tech Team",
    "Phone": "9398333762"
  },
  {
    "Name": "M. ALEKHYA",
    "Team": "Social Media Team",
    "Phone": "8317647385"
  },
  {
    "Name": "Y. NITYA",
    "Team": "Social Media Team",
    "Phone": "7893916705"
  },
  {
    "Name": "NITISH JAIN",
    "Team": "Tech Team",
    "Phone": "9000812817"
  },
  {
    "Name": "ANURAG POLA",
    "Team": "Tech Team",
    "Phone": "6300536498"
  },
  {
    "Name": "ARPAN JAIN",
    "Team": "Tech Team",
    "Phone": "8500696490"
  },
  {
    "Name": "A LAHARI",
    "Team": "Tech Team",
    "Phone": "9381146047"
  }

]}]